
<style scoped lang="scss">
.room-intro-wrapper {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px;
	background: rgba(0, 0, 0, 0.65);
	z-index: 10000;
}
.room-intro-container {
	position: fixed;
	left: 0px;
	bottom: 0;
	width: 100%;
	background: $white;
	z-index: 10100;
	max-height: $modal-height;
	transform: translate(0, 100vh);
	transition: all 0.2s ease-in-out;
	&.show {
		transform: translate(0, 0);
	}
	.t-top {
		height: 1.146667rem;
		line-height: 1.146667rem;
		color: #333;
		font-size: 16px;
		text-align: center;
		position: relative;
		border-bottom: 1px solid #ebebeb;
		span {
			font-weight: bold;
		}
		.confirm {
			position: absolute;
			display: flex;
			justify-content: center;
			align-items: center;
			right: 0;
			top: 0;
			width: 1.44rem;
			height: 100%;
			color: #f44336;
		}
	}
	.t-center {
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}
}
</style>

<template>

    <div>
        <transition name="fade">
            <div class="room-intro-wrapper"
                v-show="isOpen"
                @click.stop="closeModal">

            </div>
        </transition>

        <div class="room-intro-container"
            :class="{'show':isOpen}">
            <div class="t-top">
                <span v-text="title"></span>
                <div class="confirm"
                    @click.stop="confirm">
                    确定
                </div>

            </div>
            <div class="t-center">
                <van-picker :columns="columns"
                    @change="changeValue" />
            </div>

        </div>
    </div>
</template>

<script>
export default {
	name: "ASelect",
	components: {},
	props: {
		columns: Array,
		title: String
	},

	data() {
		return {
			isOpen: false,
			value: ""
		};
	},
	computed: {},
	watch: {},
	created() {
        this.value = this.columns[0];
    },
	mounted() {},
	destroyed() {},
	methods: {
		closeModal() {
			this.isOpen = false;
			document.querySelector("html").classList.remove("noscroll");
			window.scrollTo(0, sessionStorage.scrollY || 0);
		},
		openModal() {
			const scrollY = window.scrollY === undefined ? window.pageYOffset : window.scrollY;
			sessionStorage.scrollY = scrollY;
			this.isOpen = true;
			document.querySelector("html").classList.add("noscroll");
		},
		changeValue(p, value) {
			this.value = value;
		},
		confirm() {
			this.$emit("change", this.value);
			this.closeModal();
		}
	}
};
</script>

